<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Quản lý kiểm kê', href: '/facility/inventory' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
          <v-icon left>mdi-plus</v-icon> Tạo đợt kiểm kê
        </v-btn>
      </div>
    </div>

    <div class="px-4">
      <v-card outlined class="pa-6 mb-6 elevation-0">
        <AuditFilter ref="auditFilter" @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card outlined class="elevation-0">
        <AuditDataTable ref="auditDataTable" />
      </v-card>
    </div>

    <AuditNewDialog :state="newDialog" @updated="onAuditUpdated" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import AuditDataTable from '@/modules/facility/audit/AuditDataTable.vue'
import AuditFilter from '@/modules/facility/audit/AuditFilter.vue'

export default {
  name: 'FacilityInventory',
  components: {
    Breadcrumbs,
    AuditDataTable,
    AuditFilter,
    AuditNewDialog: () => import('@/modules/facility/audit/AuditNewDialog.vue')
  },
  data() {
    return {
      newDialog: false,
      currentFilter: {}
    }
  },
  methods: {
    onFilterChange(query) {
      this.currentFilter = query || {}
      this.$refs.auditDataTable.refresh(this.currentFilter)
    },
    onAuditUpdated() {
      this.$refs.auditDataTable.refresh(this.currentFilter)
    }
  }
}
</script>
